import { pipe, pluck, uniqBy, filter } from 'ramda';

import Http from '../../../http';
import {
  FETCH_SALES,
  PER_PAGE,
} from './constants';
import { SET_BARBER_FILTER } from '../constants';

export const fetchSalesAction = payload => ({
  type: FETCH_SALES,
  payload,
});

const fetch = (shopId, from, to, skip = 0, barberId) => {
  const url = barberId ? `/barber/${barberId}/sale` : `/shop/${shopId}/sale`;
  return Http.get(url, {
    include: 'products.product,services.service',
    createdAt__gte: from,
    createdAt__lte: to,
    sortBy: 'createdAt:asc',
    skip,
    limit: PER_PAGE,
  });
};

export const fetchSales = (shopId, from, to, barberId) =>
  async (dispatch) => {
    let hasMore = true;
    let results = [];
    let skip = 0;
    while (hasMore) {
      const data = await fetch(shopId, from, to, skip, barberId);
      if (data.count === results.length || data.rows.length === 0) {
        hasMore = false;
      }
      skip = PER_PAGE + skip;
      results = [
        ...results,
        ...data.rows,
      ];
    }

    const getBarbersForFilter = pipe(pluck('barber'), filter(Boolean), uniqBy(item => item.id));
    dispatch({ type: SET_BARBER_FILTER, payload: getBarbersForFilter(results) });
    return dispatch(fetchSalesAction(results));
  };
